export const dilution = [
  "AALSERUM",
  "ABIES CAN",
  "ABIES NIG",
  "ABROTANUM",
  "ABSINTHIUM",
  "ACALYPHA INDICA",
  "ACID ACETICUM",
  "ACID BENZ",
  "ACID CARBOLIC",
  "ACID FLUOR",
  "ACID FORMICICUM",
  "ACID GALLICUM",
  "ACID HYDROCYANIC",
  "ACID LACTICUM",
  "ACID MURIATICUM",
  "ACID NITRICUM",
  "ACID OXALICUM",
  "ACID PHOSPHORIC",
  "ACID SALICYLICUM",
  "ACID SULPH.",
  "ACID URICUM",
  "ACID PIC",
  "ACONITUM NAP",
  "ACTAEA SPICATA",
  "ADRENALINUM",
  "AESCULUS HIP.",
  "AETHUSA CYNAPIUM",
  "AGARICUS MUS.",
  "AGNUS CAST",
  "AGRAPHIS NUT",
  "ALLIUM CEPA",
  "ALLIUM SATIVUM",
  "ALOE SOC",
  "ALSTONIA CONS",
  "ALUMEN",
  "ALUMINA",
  "AMBRA G.",
  "AMMONIUM CARB",
  "AMMONIUM CAUSTICUM",
  "AMMONIUM MUR",
  "AMMONIUM PHOS",
  "AMYLIUM NIT",
  "ANACARDIUM OCC.",
  "ANACARDIUM ORI",
  "ANAGALLIS",
  "ANGUSTURA V.",
  "ANTHRACINUM",
  "ANTIMONIUM ARS.",
  "ANTIMONIUM CRUD",
  "ANTIMONIUM TART",
  "APIS MELL",
  "APOCYNUM CAN",
  "ARALIA RAC",
  "ARANEA D.",
  "ARGENTUM MET",
  "ARGENTUM NIT",
  "ARNICA MONTANA",
  "ARS. SULPH FLAV.",
  "ARS. SULPH RUB.",
  "ARSENICUM ALB",
  "ARSENICUM BROM",
  "ARSENICUM LOD",
  "ARTEMISIA VULG.",
  "ARUM TRIP",
  "ASAFOETIDA",
  "ASARUM EUROP",
  "ASTERIAS RUB.",
  "AURUM ARS.",
  "AURUM MET.",
  "AURUM MUR",
  "AURUM MUR NAT",
  "AVENA SATIVA",
  "AVIARE",
  "BACILLINUM",
  "BADIAGA",
  "BAPTISIA TINC",
  "BARYTA CARB",
  "BARYTA MUR.",
  "BARYTA IOD",
  "BARYTA PHOS",
  "BELLADONNA",
  "BELLIS PER",
  "BERBERIS AQUIFO",
  "BERBERIS VULG.",
  "BISMUTHUM MET",
  "BLATTA ORI.",
  "BORAX",
  "BOTHROPS LANC",
  "BOVISTA",
  "BROMIUM",
  "BRYONIA ALB",
  "BUFO RANA",
  "CACTUS G.",
  "CADMIUM SULF",
  "CAJEPUTUM",
  "CALADIUM SEG.",
  "CALCAREA ARS",
  "CALCAREA CARB",
  "CALCAREA FLUOR",
  "CALCAREA RENAL",
  "CALCAREA SILICATA",
  "CALCAREA SULPH",
  "CALCAREA LOD",
  "CALCAREA PHOS",
  "CALCAREA PIC",
  "CALENDULA OFF",
  "CAMPHORA",
  "CANTHARIS",
  "CAPSICUM",
  "CARBO ANIMAL",
  "CARBO SULPH",
  "CARBO VEG",
  "CARCINOSIN",
  "CARDUUS MAR",
  "CAULOPHYLLUM",
  "CAUSTICUM HAH",
  "CEANOTHUS A.",
  "CEDRON",
  "CHAMOMILLA",
  "CHELIDONIUM MAJ",
  "CHENOPODIUM AN",
  "CHIMAPHILA UMB",
  "CHINA OFF",
  "CHININUM ARS.",
  "CHININUM SULPH",
  "CHIONANTHUS V",
  "CHOLESTERINUM",
  "CICUTA V.",
  "CIMEX",
  "CIMICIFUGA",
  "CINA",
  "CINNABARIS",
  "CISTUS CAN",
  "CLEMATIS",
  "COCCULUS INDICUS",
  "COCCUS CACTI",
  "COFFEA CRUD",
  "COLCHICUM",
  "COLLINSONIA CAN",
  "COLOCYNTHIS",
  "CONDURANGO",
  "CONIUM MAC.",
  "COPAIVA",
  "CORALLIUM RUB",
  "CROCUS SAT",
  "CROTALUS HOR",
  "CROTON TIG.",
  "CUPRUM ACET.",
  "CUPRUM ARS.",
  "CUPRUM MET.",
  "CURARE",
  "CYCLAMEN",
  "DAMIANA",
  "DAPHNE INDICA",
  "DIGITALIS PUR",
  "DIOSCOREA VILL",
  "DIPHTHERINUM",
  "DOLICHOS PRU",
  "DROSERA",
  "DULCAMARA",
  "ECHINACEA ANG",
  "ELAPS COR.",
  "EPIGEA R.",
  "EQUISETUM H.",
  "ERIGERON CAN",
  "EUPATORIUM PERF",
  "EUPATORIUM PURP",
  "EUPHORBIUM",
  "EUPHRASIA",
  "FAGOPYRUM ESC",
  "FERRUM ARS.",
  "FERRUM MET.",
  "FERRUM PHOS",
  "FERRUM PIC .",
  "FERRUM LOD.",
  "FILIXMAS.",
  "FORMICA RUFA",
  "FUCUS VES.",
  "GAMBOGIA",
  "GELSEMIUM",
  "GLONOINUM",
  "GLYCERINUM",
  "GNAPHALIUM POL",
  "GRAPHITES",
  "GRINDELIA ROB",
  "GUAIACUM",
  "GUN POWDER",
  "HAMAMELIS VIRG",
  "HEKLA LAVA",
  "HELLEBORUS",
  "HELONIAS D",
  "HEPAR SULPH",
  "HYDRASTIS CAN",
  "HYDROCOTYLE AS",
  "HYDROPHOBINUM (LYSSINUM)",
  "HYOSCYAMUS NIG",
  "HYPERICUM PERF",
  "IBERIS AMARA",
  "IGNATIA AMAR",
  "INFLUENZINUM",
  "INSULINUM",
  "IODIUM",
  "IPECACUANHA",
  "IRIS TENAX",
  "IRIS VER",
  "JABORANDI",
  "JALAPA",
  "JATROPHA C.",
  "JUGLANS R",
  "JUSTICIA AD",
  "KALI ARS.",
  "KALI BICH",
  "KALI BROM",
  "KALI CARB",
  "KALI MUR",
  "KALI NIT",
  "KALI PHOS",
  "KALI SULPH",
  "KALI IOD",
  "KALMIA LAT.",
  "KREOSOTUM",
  "LAC CAN",
  "LAC DEF (LAC VAC DEF)",
  "LACHESIS",
  "LACHNANTHES T",
  "LAPIS ALB.",
  "LATHYRUS SAT.",
  "LATRODECTUS M",
  "LAUROCERASUS",
  "LEDUM PAL",
  "LEMNA MINOR",
  "LEPTANDRA",
  "LILLIUM TIG.",
  "LITHIUM CARB",
  "LOBELIA INF",
  "LYCOPODIUM",
  "LYCOPUS V.",
  "MACROTINUM",
  "MAGN. CARB",
  "MAGN. MUR",
  "MAGN. PHOS",
  "MALANDRINUM",
  "MANGANUM ACET.",
  "MANGANUM MET",
  "MEDORRHINUM",
  "MELILOTUS OFF",
  "MENTHA PIP",
  "MEPHITIS PUT",
  "MERC COR",
  "MERC IOD FLAV",
  "MERC IOD RUB",
  "MERC SOL",
  "MERC VIV",
  "MERC. CYAN",
  "MERC.DUL",
  "MEZEREUM",
  "MILLEFOLIUM",
  "MORBILLINUM",
  "MOSCHUS",
  "MUREX PURP",
  "MYRISTICA",
  "NAJA T.",
  "NAPHTHALINUM",
  "NATRUM MURIATICUM",
  "NATRUM PHOS",
  "NATRUM SALICY",
  "NATRUM ARS.",
  "NATRUM CARB.",
  "NATRUM SULPH",
  "NUX VOMICA",
  "NUX MOSCH",
  "OCIMUM CAN.",
  "OENANTHE CROC",
  "OLEANDER",
  "OLEUM JEC",
  "ONOSMODIUM V",
  "OPIUM",
  "ORNITHOGALUM U",
  "OSMIUM MET",
  "OVA TESTA",
  "PAEONIA OFF",
  "PAROTIDINUM",
  "PERTUSSIN",
  "PETROLEUM",
  "PETROSELINUM",
  "PHOSPHORUS",
  "PHYSOSTIGMA VEN",
  "PHYTOLACCA BERRY",
  "PHYTOLACCA DEC",
  "PICHI",
  "PIX LIQ.",
  "PLANTAGO M.",
  "PLATINUM MET",
  "PLUMBUM LOD",
  "PLUMBUM MET.",
  "PODOPHYLLUM PEL",
  "POTHOS FOET.",
  "PSORINUM",
  "PULSATILLA",
  "PYROGENIUM",
  "RADIUM BROM",
  "RANUNCULUS B",
  "RAPHANUS SAT.",
  "RATANHIA",
  "RHEUM",
  "RHODODENDRON",
  "RHUS TOX",
  "RHUS VEN",
  "RICINUS COM",
  "ROBINIA PSEUD",
  "ROSMARINUS OFF.",
  "RUMEX CRIS.",
  "RUTA G",
  "SABADILLA",
  "SABAL SERR",
  "SABINA",
  "SAMBUCUS CAN",
  "SAMBUCUS NIG.",
  "SANGUINARIA CAN",
  "SANGUINARINUM NIT",
  "SANICULA A.",
  "SANTONINUM",
  "SARSAPARILLA",
  "SCIRRHINUM",
  "SECALA COR",
  "SELENIUM",
  "SENECIO A",
  "SENEGA",
  "SEPIA",
  "SILICEA",
  "SOLIDAGO V.",
  "SPIGELIA",
  "SPONGIA",
  "SQUILLA",
  "STANNUM MET",
  "STAPHYSAGRIA",
  "STICTA P.",
  "STRAMONIUM",
  "STRONTIUM CARB",
  "STROPHANTHUS",
  "STRYCHNINUM",
  "SULPHUR (SULFUR)",
  "SULPHUR LOD.",
  "SYMPHYTUM",
  "SYPHILINUM",
  "TABACUM",
  "TARAXACUM",
  "TARENTULA C.",
  "TARENTULA H.",
  "TELLURIUM",
  "TEREBINTHINA",
  "TEUCRUM M.V.",
  "THALLIUM MET",
  "THERIDION C",
  "THIOSINAMINUM",
  "THLASPI B.P.",
  "THUJA OCCID",
  "THYMOLUM",
  "THYROIDINUM",
  "TITANIUM MET",
  "TRILLIUM PEND",
  "TROMBIDIUM",
  "TUBERCULINUM KOCH",
  "TUBERCULINUM BOV",
  "TYPHOIDINUM",
  "URANIUM NIT",
  "UREA",
  "URTICA UREN",
  "USTILAGO",
  "VACCININUM",
  "VALERIANA OFF",
  "VANADIUM",
  "VARIOLINUM",
  "VERATRUM VIR",
  "VERATRUM ALB",
  "VERBASCUM THA",
  "VIBURNUM OP",
  "VINCA MINOR",
  "VIOLA ODOR",
  "VIOLA TRI",
  "VIPERA ASP",
  "VIPERA B",
  "VISCUM ALB",
  "WIESBADEN",
  "WYETHIA HELENIOIDES",
  "X-RAY",
  "ZINCUM PHOS",
  "ZINCUM PIC",
  "ZINCUM SULF",
  "ZINCUM MET",
  "ZINGIBER",
];

export const biochemic = [
  // Existing Reckeweg Biochemics
  "Calcarea Fluor",
  "Calcarea Phos",
  "Calcarea Sulf",
  "Ferrum Phos",
  "Five Phos",
  "Kali Mur",
  "Kali Phosphoricum",
  "Kali Sulf",
  "Mag Phos",
  "Nat Mur",
  "Nat Phos",
  "Nat Sulf",
  "Silicea",

  // SBL Biochemics
  "SBL Calcarea Fluorica",
  "SBL Calcarea Phosphorica",
  "SBL Calcarea Sulphurica",
  "SBL Ferrum Phosphoricum",
  "SBL Five Phos",
  "SBL Kali Muriaticum",
  "SBL Kali Phosphoricum",
  "SBL Kali Sulphuricum",
  "SBL Magnesia Phosphorica",
  "SBL Natrum Muriaticum",
  "SBL Natrum Phosphoricum",
  "SBL Natrum Sulphuricum",
  "SBL Silicea"
];

 export const bc = [
  // Existing Reckeweg BC
  ...Array.from({ length: 28 }, (_, i) => `BC ${i + 1}`),
  

  // SBL BC
  "SBL BC 1",
  "SBL BC 2",
  "SBL BC 3",
  "SBL BC 4",
  "SBL BC 5",
  "SBL BC 6",
  "SBL BC 7",
  "SBL BC 8",
  "SBL BC 9",
  "SBL BC 10",
  "SBL BC 11",
  "SBL BC 12",
  "SBL BC 13",
  "SBL BC 14",
  "SBL BC 15",
  "SBL BC 16",
  "SBL BC 17",
  "SBL BC 18",
  "SBL BC 19",
  "SBL BC 20",
  "SBL BC 21",
  "SBL BC 22",
  "SBL BC 23",
  "SBL BC 24",
  "SBL BC 25",
  "SBL BC 26",
  "SBL BC 27",
  "SBL BC 28"
];
export const sblBiochemicPrices = {
  "3X": 120,
  "6X": 120,
  "12X": 120,
  "30X": 120,
};
export const sblBcPrices = Object.fromEntries(
  bc
    .filter(name => name.startsWith("SBL BC "))
    .map(name => [name, 120])
);
export const rdrops = [
  "R 1",
  "R 2",
  "R 3",
  "R 4",
  "R 5",
  "R 6",
  "R 7",
  "R 8",
  "R 9",
  "R 10",
  "R 11",
  "R 12",
  "R 13",
  "R 14",
  "R 16",
  "R 17",
  "R 18",
  "R 19",
  "R 20",
  "R 21",
  "R 22",
  "R 23",
  "R 24",
  "R 25",
  "R 26",
  "R 27",
  "R 28",
  "R 29",
  "R 30",
  "R 31",
  "R 32",
  "R 33",
  "R 34",
  "R 35",
  "R 36",
  "R 37",
  "R 38",
  "R 39",
  "R 40",
  "R 41",
  "R 42",
  "R 43",
  "R 44",
  "R 45",
  "R 46",
  "R 47",
  "R 48",
  "R 49",
  "R 50",
  "R 51",
  "R 52",
  "R 53",
  "R 54",
  "R 55",
  "R 56",
  "R 57",
  "R 58",
  "R 59",
  "R 60",
  "R 62",
  "R 63",
  "R 64",
  "R 65",
  "R 66",
  "R 67",
  "R 68",
  "R 69",
  "R 70",
  "R 71",
  "R 72",
  "R 73",
  "R 74",
  "R 75",
  "R 76",
  "R 77",
  "R 78",
  "R 81",
  "R 89",
  "R 96",
  "R 109",
  "R 131",
  "R 184",
  "R 188",
  "R 191",
  "R 193"
];

export const sblLiquidSpecialities = [
  "SBL Drops No.1",
  "SBL Drops No.2",
  "SBL Drops No.3",
  "SBL Drops No.4",
  "SBL Drops No.5",
  "SBL Drops No.6",
  "SBL Drops No.7",
  "SBL Drops No.8",
  "SBL Drops No.9",
  "SBL Drops No.10",

  "SBL Drops No.-11-(Sleep Support)",
  "SBL Drops No.-12-(Tonsils Care)",
  "SBL Drops No.-13-(Acidity&Indig)",
  "SBL Drops No.-14-(Leuco Care)",
  "SBL Drops No.-15-(Acne&Pim.Care)",
  "SBL Drops No.-16-(Bone Health)",
  "SBL Drops No.-17-(Piles & F Care)",
  "SBL Drops No.-18-(Anaemia Suppt)",
  "SBL Drops No.-19-(Anti-Flu)",
  "SBL Drops No.-20-(Injury Aid)",
  "SBL Drops No.-21-(Stress Relief)",

  "SBL Ache-Nil Drops",
  "SBL Constinil Drops",
 
  "RelaXhed Drops",
  "Stobal Cough Syrup",
  "Tonicard Gold Drop",
  "Utrofyne Syrup",
  "Vertefine Drops",
  "Wormorid Drops",

  "Nixocid Syrup",

  "Orthomuv Syrup",
  "Orthomuv Massage Oil Roll-On",

  "Funginil Drops",

  "LIV T [Sugar Free]",
  "Rinsout Drops - Mouthwash",
  "Wipe Clear Acne Lotion",
  "LIV T [Sugar Free]",
  "Rinsout Drops - Mouthwash",

  // ADEL PRODUCTS

  "ADEL - 10 Respiratory Drops",
  "ADEL - 19 MentalPhysical tiredness (General Weakness) Drops",
  "Adel 1- Headache & Migraine Drops",
  "Adel 11 - Constipation Drops",
  "ADEL 12 - Skin Drops",
  "ADEL 13 - Weight Management Drops",
  "ADEL 14 - Iron Deficiency Drops",
  "ADEL 15 - Women’s White Discharge Drops",
  "ADEL 16 - Gastrointestinal Drops",
  "ADEL 17 - Eye Care Drops",
  "ADEL 18 - Diabetes Management Drops",
  "ADEL 2 - Piles & Hemorrhoids Drops",
  "ADEL 20 - Allergy Drops",
  "ADEL 21 - Prostate Drops",
  "ADEL 22 - Kidney Drops",
  "ADEL 23 - Sinusitis Drops",
  "ADEL 24 - Tonsils Drops",
  "ADEL 25 - Sleep Disorder Drops",
  "ADEL 26 - Osteoarthritis Drops",
  "ADEL 27 - Injury Drops",
  "ADEL 28 - Cholesterol Management Drops",
  "ADEL 29 - UTI Drops",
  "ADEL 3 - Jaundice & Liver Drops",
  "ADEL 31 - Periods Regulating (PCOS, PCOD)",
  "ADEL 32 - Inflammation Drops",
  "ADEL 33 - Oedema Drops",
  "ADEL 34 - Spleen Drops",
  "Adel 36 - Vitality Drops",
  "ADEL 38 - Cramp Pain Drops",
  "ADEL 39 - Sciatica Drops",
  "ADEL 4 - Joint Pain Drops",
  "ADEL 40 - Warts Drops",
  "ADEL 43 - Heart & Cardiovascular Drops",
  "ADEL 44 - Varicose Veins Drops",
  "ADEL 48 - Lymph & Tumour Drops (adjuvant)",
  "ADEL 49 - Diarrhoea Drops",
  "Adel 5 - Acidity, Gas & Stomach Drops",
  "ADEL 50 - Worms Drops",
  "Adel 51 - Anxiety & Stress Drops",
  "ADEL 54 - Heart Care Drops",
  "ADEL 55 - Spondylitis Drops",
  "ADEL 56 - Immune System Drops",
  "ADEL 57 - Digestion Drops",
  "ADEL 6 - Thyroid Management Drops",
  "ADEL 61 - Adrenal Gland Drops",
  "ADEL 64 - Uric Acid Drops",
  "ADEL 65 - Body Temperature Management Drops",
  "ADEL 66 - Detoxification Drops",
  "ADEL 69 - Circulatory Drops",
  "ADEL 7 - Cough Drops",
  "ADEL 73 - Anti-fungal Drops",
  "ADEL 75 - Pain Relief Ointment",
  "ADEL 78 - Skin Ointment",
  "ADEL 79 - Iron Tonic",
  "ADEL 8 - Blood Pressure Management Drops",
  "ADEL 82 - Liver Tonic",
  "ADEL 83 - Cough Syrup",
  "ADEL 85 - Energy Drops",
  "ADEL 85 - Vitality Tonic",
  "ADEL 86 - Warts (External)",
  "ADEL 87 - Infection Drops",
  "ADEL 9 - Hair Care Drops",

  // Additional Schwabe Products

  "Gastrobin",
  "Essentia Aurea",
  "Diacard",
  "Biofungin",
  "Bryorheum",

];

export const sblLiquidSpecialityPrices = {
  "Nixocid Syrup": {
    "115 ml": 122,
    "500 ml": 314,
  },

  "Stobal Cough Syrup": {
    "115 ml": 117,
    "180 ml": 178,
    "500 ml": 309,
  },

  "Tonicard Gold Drop": {
    "30 ml": 211,
    "200 ml": 436,
  },
  "SBL Drops No.1": 183,
  "SBL Drops No.2": 183,
  "SBL Drops No.3": 183,
  "SBL Drops No.4": 183,
  "SBL Drops No.5": 183,
  "SBL Drops No.6": 183,
  "SBL Drops No.7": 183,
  "SBL Drops No.8": 183,
  "SBL Drops No.9": 183,
  "SBL Drops No.10": 183,

  "SBL Drops No.-11-(Sleep Support)": 183,
  "SBL Drops No.-12-(Tonsils Care)": 183,
  "SBL Drops No.-13-(Acidity&Indig)": 183,
  "SBL Drops No.-14-(Leuco Care)": 183,
  "SBL Drops No.-15-(Acne&Pim.Care)": 183,
  "SBL Drops No.-16-(Bone Health)": 183,
  "SBL Drops No.-17-(Piles & F Care)": 183,
  "SBL Drops No.-18-(Anaemia Suppt)": 183,
  "SBL Drops No.-19-(Anti-Flu)": 183,
  "SBL Drops No.-20-(Injury Aid)": 183,
  "SBL Drops No.-21-(Stress Relief)": 183,

  "SBL Ache-Nil Drops": 110,
  "SBL Constinil Drops": 131,

  "RelaXhed Drops": 131,
  "Utrofyne Syrup": 117,
  "Vertefine Drops": 155,
  "Wormorid Drops": 136,

  "Orthomuv Syrup" : 185,
  "Orthomuv Massage Oil Roll-On": 98,

  "Funginil Drops": 127,

  "LIV T [Sugar Free]": 117,
  "Rinsout Drops - Mouthwash": 113,
  "Wipe Clear Acne Lotion": 98
};

export const sblHealthWellness = [
  // Eye & Ear Drops
  "Euphrasia 10% Eye Drops",
  "Cineraria Maritima 10% Eye Drops",
  "Mullein Ear Drops",
  "Cineraria Maritima Euphrasia Eye Drops",
  
  "Scalptone Tablets",
 

  // Skin Care
  "Sulphur Ointment",
  "Babchi Oil",
  "Sulphur Gel",
  "Urtica Urens Ointment",
  "Thuja Ointment",
  "Cardiospermum Helicacabum Ointment",
  "Echinacea Ointment",
  "Petroleum Ointment",

  // Additional Ointments
  "Funginil Cream",
  "Hypericum Ointment",
  "Hamamelis Ointment",
  "Rhustox Ointment",
  "Graphites Ointment",
  "Ruta Ointment",
  // ==========================================
  // SCHWABE INDIA PRODUCTS
  // ==========================================

  // Soaps
  "B&T Glow & Fairness Soap",
  "B&T Akne-Sor Soap",

  // Ointments
  "Heal Plus Cream",
  "Topi Azadirachta Cream",
  "Ruck Pain Gel",

  // Eye & Ear Drops
  "Cineraria Maritima Schwabe Eye Drops",

  // Liquid Specialities
  "ALPHA-LIV SUGAR FREE",
  "Lilium tigr. Pentarkan",
  "Dizester",
  "Hertone",
  "Gnaphalium Pentarkan",
  "Alpha-Liv-Drops",
  "Zauber Hair Drops",
  "Good Morning",

  // Skin Care
  "B&T Nourish collection Body Lotion",
  "B&T Nourish Collection Body Wash",
  "B&T Foot Cream",
  "B&T NOURISH COLLECTION SPF 50 SUNSCREEN",
  "B&T Nourish Collection Face Wash",
  "B&T Aloe Vera Gel 100GM",
  "B&T NOURISH COLLECTION SKIN RADIANCE CREAM",
  "B&T Aloe Vera Cream",

  // Tablet Specialities
  "Guatteria gaumeri 1x",
  "Baptisia tinctoria 1X MT tabs",
  "Fucus vesiculosus 1x MT Tabs",
  "Crataegus oxyacantha 1x MT tabs",
  "Sabal serrulata 1x MT Tabs",
  "Ginkgo biloba 1X",

  // Hair Care
  "B&T 7oL",
  "B&T Anti-Dandruff Oil",
  "B&T Arnica Shampoo 2 in 1",
  "B&T Hair Serum",
  "B&T Anti-Dandruff Shampoo",
  "B&T Arnica Shampoo",
  "B&T Hair Growth Oil",
  "Zauberöl - Premium Hair Growth Oil",
  "B&T Nourish Collection Repair & Shine Shampoo",
  ];export const sblHealthWellnessPrices = {
  // Existing Health products
  "Euphrasia 10% Eye Drops": 122,
  "Cineraria Maritima 10% Eye Drops": 140,
  "Mullein Ear Drops": 56,
  "Cineraria Maritima Euphrasia Eye Drops": 122,
  "Scalptone Tablets": 165,

  "Sulphur Ointment": 80,
  "Babchi Oil": 141,
  "Urtica Urens Ointment": 80,
  "Thuja Ointment": 80,
  "Cardiospermum Helicacabum Ointment": 80,
  "Echinacea Ointment": 80,
  "Petroleum Ointment": 80,
  "Funginil Cream": 80,
  "Hypericum Ointment": 80,
  "Hamamelis Ointment": 80,
  "Rhustox Ointment": 80,
  "Graphites Ointment": 80,
  "Ruta Ointment": 80,

  // ==========================================
  // SCHWABE INDIA — SOAPS
  // ==========================================

  "B&T Glow & Fairness Soap": {
    "75 g": 35,
  },

  "B&T Akne-Sor Soap": {
    "75 g": 35,
  },

  // ==========================================
  // SCHWABE INDIA — OINTMENTS / GELS
  // ==========================================

  "Heal Plus Cream": {
    "25 g": 71,
  },

  "Topi Azadirachta Cream": {
    "25 g": 72,
  },

  "Ruck Pain Gel": {
    "25 g": 71,
  },

  // ==========================================
  // SCHWABE INDIA — EYE & EAR
  // ==========================================

  "Cineraria Maritima Schwabe Eye Drops": {
    "10 ml": 245,
  },

  // ==========================================
  // SCHWABE INDIA — LIQUID SPECIALITIES
  // ==========================================

  "ALPHA-LIV SUGAR FREE": 135,

  "Lilium tigr. Pentarkan": {
    "30 ml": 162,
  },

  "Dizester": {
    "100 ml": 102,
    "200 ml": 165,
    "500 ml": 322,
  },

  "Hertone": {
    "100 ml": 202,
    "200 ml": 364,
  },

  "Gnaphalium Pentarkan": {
    "30 ml": 162,
  },

  "Alpha-Liv-Drops": {
    "30 ml": 113,
  },

  "Zauber Hair Drops": {
    "Standard": 0,
  },

  "Good Morning": {
    "30 ml": 113,
  },

  // ==========================================
  // SCHWABE INDIA — SKIN CARE
  // ==========================================


  "B&T Nourish collection Body Lotion": 559,

  "B&T Nourish Collection Body Wash": 479,

  "B&T Foot Cream": 104,

  "B&T NOURISH COLLECTION SPF 50 SUNSCREEN": 399,

  "B&T Nourish Collection Face Wash": 319,

  "B&T Aloe Vera Gel 100GM": {
    "100 g": 119,
  },

  "B&T NOURISH COLLECTION SKIN RADIANCE CREAM": 639,

  "B&T Aloe Vera Cream": 108,

  // ==========================================
  // SCHWABE INDIA — TABLET SPECIALITIES
  // ==========================================

  "Guatteria gaumeri 1x": {
    "20 g": 280,
  },

  "Baptisia tinctoria 1X MT tabs": {
    "20 g": 156,
  },

  "Fucus vesiculosus 1x MT Tabs": {
    "20 g": 156,
  },

  "Crataegus oxyacantha 1x MT tabs": {
    "20 g": 156,
  },

  "Sabal serrulata 1x MT Tabs": {
    "20 g": 137,
  },

  "Ginkgo biloba 1X": {
    "20 g": 280,
  },

  // ==========================================
  // SCHWABE INDIA — HAIR CARE
  // ==========================================

  "B&T 7oL": 125,

  "B&T Anti-Dandruff Oil": 96,

  "B&T Arnica Shampoo 2 in 1": 208,

  "B&T Hair Serum": 392,

  "B&T Anti-Dandruff Shampoo": 103,

  "B&T Arnica Shampoo": {
    "Standard": 100,
    "250 ml": 142,
  },



  "B&T Hair Growth Oil": 128,

  "Zauberöl - Premium Hair Growth Oil": 559,


  "B&T Nourish Collection Repair & Shine Shampoo": 569,
};

// ==========================================
// DR. RECKEWEG PRICES
// ==========================================

// DILUTIONS - 11 ml
export const dilutionPrices = {
  "30": 180,
  "200": 205,
  "1M": 255,
  "10M": 275,
  "CM": 355,
};

// BIOCHEMIC TABLETS - 20 g
export const biochemicPrices = {
  "3X": 245,
  "6X": 245,
  "12X": 245,
  "30X": 245,
  "200X": 350,
};

// BIOCOMBINATIONS - 20 g
export const bcPrices = Object.fromEntries(
  bc.map(name => [name, 245])
);

// R-SERIES
export const rdropPrices = Object.fromEntries(
  rdrops.map(name => [name, 325])
);

// R-Series products with different MRP
Object.assign(rdropPrices, {
  "R 8": 600,
  "R 30": 795,
  "R 96": 805,
  "R 109": 400,
  "R 131": 675,
});

export const motherPrices = {
  "AALSERUM 7X": 325,
  "ABROTANUM Q": 380,
  "ABSINTHIUM Q": 380,
  "ACID PHOS Q": 325,
  "ACID SULPH 2X": 325,
  "ACONITE (ACONITUM NAP) Q": 325,
  "ACTAEA SPICATA Q": 435,
  "ADONIS VERNALIS Q": 475,
  "AESCULUS HIPP Q": 325,
  "AGARICUS MUSCARIUS Q": 380,
  "AGNUS CASTUS Q": 325,
  "ALETRIS FARINOSA Q": 380,
  "ALFALFA Q": 325,
  "ALLIUM SATIVUM Q": 380,
  "ALOE SOC Q": 380,
  "AMMI VISNAGA Q": 325,
  "AMYL NITROSUM 3X": 325,
  "ANGELICA ARCH Q": 435,
  "APIS MELLIFICA Q": 380,
  "APOCYNUM CAN Q": 325,
  "ARALIA RACEMOSA Q": 435,
  "ARNICA MONTANA Q": 380,
  "ARTEMISIA VULGARIS Q": 325,
  "ASHWAGANDHA Q": 435,
  "ASPIDOSPERMA Q": 435,
  "AVENA SATIVA Q": 325,
  "AZADIRACHTA INDICA Q": 325,
  "BACOPA MONNIERI (BRAHMI) Q": 325,
  "BAPTISIA TINCTORIA Q": 380,
  "BELLADONNA Q": 325,
  "BELLIS PERENNIS Q": 325,
  "BERBERIS AQUIFOLIUM Q": 380,
  "BERBERIS VULGARIS Q": 325,
  "BLATTA ORIENTALIS Q": 605,
  "BORAX Q": 325,
  "BRYONIA ALBA Q": 325,
  "CACTUS GRAND Q": 380,
  "CALADIUM SEGUINUM Q": 475,
  "CALENDULA Q": 325,
  "CALOTROPIS GIGANTEA Q": 380,
  "CAMPHORA Q": 325,
  "CANTHARIS 7X": 325,
  "CANTHARIS Q": 435,
  "CARDUUS MARIANUS Q": 325,
  "CARICA PAPAYA Q": 435,
  "CASCARA SAGRADA Q": 380,
  "CAULOPHYLLUM Q": 380,
  "CAUSTICUM 2X": 325,
  "CEANOTHUS AMER Q": 380,
  "CEPHALANDRA INDICA Q": 325,
  "CHELIDONIUM MAJUS Q": 325,
  "CHELONE GLABRA Q": 605,
  "CHENOPODIUM Q": 380,
  "CHIMAPHILA Q": 380,
  "CHINA Q": 325,
  "CHIONANTHUS VIRG Q": 475,
  "CIMICIFUGA Q": 380,
  "CINA Q": 435,
  "COLCHICUM Q": 435,
  "COLLINSONIA Q": 380,
  "COLOCYNTHIS Q": 325,
  "CONDURANGO Q": 325,
  "CONIUM MAC Q": 380,
  "CONVALLARIA MAJALIS Q": 380,
  "CRATAEGUS Q": 325,
  "CURCUMA LONGA Q": 325,
  "DAMIANA Q": 325,
  "DIGITALIS PURPUREA Q": 325,
  "DIOSCOREA VILLOSA Q": 380,
  "ECHINACEA ANG Q": 380,
  "ECHINACEA PURPUREA Q": 380,
  "EPIGAEA REPENS 2X": 325,
  "EQUISETUM HYEMALE Q": 435,
  "ERIGERON CANADENSE Q": 435,
  "EUPATORIUM PERF Q": 380,
  "EUPHRASIA Q": 325,
  "FILIX MAS Q": 380,
  "FORMICA RUFA 3X": 325,
  "FRAXINUS AMERICANA Q": 380,
  "FUCUS VESICULOSUS Q": 325,
  "GALIUM APARINE Q": 435,
  "GAULTHERIA PROC Q": 380,
  "GELSEMIUM SEMP Q": 380,
  "GENTIANA LUTEA Q": 435,
  "GINKGO BILOBA Q": 475,
  "GINSENG Q": 380,
  "GLONOINUM 3X": 325,
  "GOSSYPIUM Q": 380,
  "GRINDELIA ROBUSTA Q": 435,
  "GUAIACUM Q": 605,
  "GYMNEMA SYLVESTRE Q": 325,
  "HAMAMELIS VIRGINICA Q": 380,
  "HEDERA HELIX Q": 435,
  "HELLEBORUS NIGER Q": 380,
  "HELONIAS DIOICA Q": 605,
  "HYDRANGEA Q": 435,
  "HYDRASTIS CAN 7X": 325,
  "HYDROCOTYLE Q": 325,
  "HYOSCYAMUS NIGER Q": 380,
  "HYPERICUM PERF Q": 380,
  "IBERIS AMARA Q": 380,
  "IGNATIA Q": 380,
  "IODIUM Q": 380,
  "IPECACUANHA Q": 380,
  "IRIS VERSICOLOR Q": 380,
  "JABORANDI Q": 325,
  "JANOSIA ASHOKA Q": 380,
  "JUSTICIA ADHATODA Q": 325,
  "KALMEGH Q": 435,
  "KREOSOTUM 3X": 325,
  "LATHYRUS SATIVUS Q": 380,
  "LEDUM PALUSTRE Q": 325,
  "LEMNA MINOR Q": 380,
  "LIATRIS SPICATA Q": 435,
  "LILIUM TIGRINUM Q": 380,
  "LOBELIA INFLATA Q": 435,
  "LYCOPODIUM CLAVATUM Q": 325,
  "LYCOPUS VIRGINICUS Q": 380,
  "MELILOTUS OFFICINALIS Q": 380,
  "MILLEFOLIUM Q": 380,
  "MULLEIN OIL": 435,
  "MYRICA CERIFERA Q": 435,
  "MYRISTICA SEBIFERA Q": 605,
  "NUPHAR LUTEUM Q": 435,
  "NUX VOMICA Q": 325,
  "OCIMUM CAN Q": 325,
  "OENANTHE CROCATA Q": 380,
  "ORNITHOGALUM UMB Q": 435,
  "PAREIRA BRAVA Q": 475,
  "PASSIFLORA INC Q": 380,
  "PHYTOLACCA BERRY Q": 380,
  "PHYTOLACCA DEC Q": 325,
  "PINUS LAMB Q": 605,
  "PLANTAGO MAJOR Q": 325,
  "PODOPHYLLUM Q": 435,
  "POTHOS FOETIDUS Q": 435,
  "PULSATILLA Q": 380,
  "QUERCUS E GLAND Q": 380,
  "RATANHIA Q": 380,
  "RAUWOLFIA SERPENTINA Q": 435,
  "RHUS AROMATICA Q": 605,
  "RHUS TOX Q": 605,
  "RICINUS COMMUNIS Q": 380,
  "ROBINIA PSEUD Q": 380,
  "RUBIA TINCTORUM Q": 435,
  "RUMEX CRISPUS Q": 380,
  "RUTA GRAVEOLENS Q": 325,
  "SABAL SERRULATA Q": 325,
  "SABINA Q": 380,
  "SALIX NIGRA Q": 475,
  "SANGUINARIA CAN Q": 435,
  "SARSAPARILLA Q": 325,
  "SCROPHULARIA NODOSA Q": 380,
  "SECALE CORNUTUM Q": 605,
  "SEMPERVIVUM TECT Q": 435,
  "SENECIO AUREUS 2X": 325,
  "SENEGA Q": 325,
  "SOLIDAGO VIRGAUREA Q": 325,
  "SPARTIUM SCOPARIUM Q": 435,
  "SPIGELIA Q": 380,
  "SPONGIA TOSTA 2X": 325,
  "STAPHYSAGRIA Q": 435,
  "STELLARIA MEDIA Q": 435,
  "STERCULIA (COLA) Q": 380,
  "STROPHANTHUS Q": 380,
  "SYMPHYTUM Q": 435,
  "SYZYGIUM JAMB Q": 325,
  "TEUCRIUM M.V. Q": 435,
  "THLASPI B.P. Q": 380,
  "THUJA OCCIDENTALIS Q": 325,
  "TRIBULUS TERRESTRIS Q": 380,
  "TRILLIUM PEND Q": 380,
  "URTICA URENS Q": 325,
  "USNEA BARBATA Q": 380,
  "USTILAGO MAY Q": 325,
  "UVA URSI Q": 435,
  "VALERIANA OFF Q": 435,
  "VERBASCUM Q": 325,
  "VIBURNUM OPULUS Q": 325,
  "VIBURNUM PRUN Q": 380,
  "VINCA MINOR Q": 380,
  "VISCUM ALBUM Q": 325,
  "XANTHOZYLUM Q": 380,
  "YERBA SANTA Q": 435,
  "YOHIMBINUM Q": 475
};
export const adelPrices = {
  // Standard ADEL products
  "ADEL - 10 Respiratory Drops": 355,
  "ADEL - 19 MentalPhysical tiredness (General Weakness) Drops": 355,
  "Adel 1- Headache & Migraine Drops": 355,
  "Adel 11 - Constipation Drops": 355,
  "ADEL 12 - Skin Drops": 355,
  "ADEL 13 - Weight Management Drops": 355,
  "ADEL 14 - Iron Deficiency Drops": 355,
  "ADEL 15 - Women’s White Discharge Drops": 355,
  "ADEL 16 - Gastrointestinal Drops": 355,
  "ADEL 17 - Eye Care Drops": 355,
  "ADEL 18 - Diabetes Management Drops": 355,
  "ADEL 2 - Piles & Hemorrhoids Drops": 355,
  "ADEL 20 - Allergy Drops": 355,
  "ADEL 21 - Prostate Drops": 355,
  "ADEL 22 - Kidney Drops": 355,
  "ADEL 23 - Sinusitis Drops": 355,
  "ADEL 24 - Tonsils Drops": 355,
  "ADEL 25 - Sleep Disorder Drops": 355,
  "ADEL 26 - Osteoarthritis Drops": 355,
  "ADEL 27 - Injury Drops": 355,
  "ADEL 28 - Cholesterol Management Drops": 355,
  "ADEL 29 - UTI Drops": 355,
  "ADEL 3 - Jaundice & Liver Drops": 355,
  "ADEL 31 - Periods Regulating (PCOS, PCOD)": 355,
  "ADEL 32 - Inflammation Drops": 355,
  "ADEL 33 - Oedema Drops": 355,
  "ADEL 34 - Spleen Drops": 355,
  "Adel 36 - Vitality Drops": 355,
  "ADEL 38 - Cramp Pain Drops": 355,
  "ADEL 39 - Sciatica Drops": 355,
  "ADEL 4 - Joint Pain Drops": 355,
  "ADEL 40 - Warts Drops": 355,
  "ADEL 43 - Heart & Cardiovascular Drops": 355,
  "ADEL 44 - Varicose Veins Drops": 355,
  "ADEL 48 - Lymph & Tumour Drops (adjuvant)": 355,
  "ADEL 49 - Diarrhoea Drops": 355,
  "Adel 5 - Acidity, Gas & Stomach Drops": 355,
  "ADEL 50 - Worms Drops": 355,
  "Adel 51 - Anxiety & Stress Drops": 355,
  "ADEL 54 - Heart Care Drops": 355,
  "ADEL 55 - Spondylitis Drops": 355,
  "ADEL 56 - Immune System Drops": 355,
  "ADEL 57 - Digestion Drops": 355,
  "ADEL 6 - Thyroid Management Drops": 355,
  "ADEL 61 - Adrenal Gland Drops": 355,
  "ADEL 64 - Uric Acid Drops": 355,
  "ADEL 65 - Body Temperature Management Drops": 355,
  "ADEL 66 - Detoxification Drops": 355,
  "ADEL 69 - Circulatory Drops": 355,
  "ADEL 7 - Cough Drops": 355,
  "ADEL 73 - Anti-fungal Drops": 355,
  "ADEL 86 - Warts (External)": 355,
  "ADEL 87 - Infection Drops": 355,

  // Exceptions
  "ADEL 40+86 Warts Combination": 626,
  "ADEL 75 - Pain Relief Ointment": 510,
  "ADEL 78 - Skin Ointment": 510,
  "ADEL 79 - Iron Tonic": 860,
  "ADEL 82 - Liver Tonic": 510,
  "ADEL 83 - Cough Syrup": 510,
  "ADEL 85 - Vitality Tonic": 750,
  "ADEL 85 - Energy Drops": 1250,
};
